import React from "react";
import {NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import {useLocationFormState} from "../../components/timberStorage/TimberStorageForm/TimberStorageAddForm";
import TimberStorageAddFormProvider from "../../components/timberStorage/TimberStorageForm/TimberStorageAddFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const TimberStorageAddEditPage = () => {

    useTitle(t`Add Timber Storage`);

    return (
        <Box data-testid="TimberStorage-add-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="TimberStorage-add-title"
                    >
                        <Trans>Add Timber Storage</Trans>
                    </Typography>
                    <TimberStorageAddFormProvider
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default TimberStorageAddEditPage;
